<button mat-icon-button [class.selected]="(shopOrder$ | async)?.shippingAddressRegion">
  <span
    [matBadge]="(shopOrder$ | async)?.shippingAddressRegion ? '✔' : '!'"
    matBadgePosition="after"
    matBadgeSize="small"
    [ngClass]="(shopOrder$ | async)?.shippingAddressRegion ? 'region-set' : 'region-not-set'"
  >
    <fa-icon icon="map-pin"></fa-icon>
  </span>
</button>
